/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

const CheckBox = ({ item, style, rightComponent }) => {
  return (
    <div style={{ paddingTop: 7.5, display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
      <label
        className="form-li"
        key={`checkbox-${item.value}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <input
          type="checkbox"
          className="chk"
          checked
          onChange={() => null}
          style={{ position: "absolute", ...style }}
        />
        <span className="chkmrk" style={style}></span>
        <span className="lbl-txt" style={{ marginTop: 1, marginLeft: -2 }}>
          {item.label}
        </span>
      </label>
      {rightComponent ? rightComponent(item) : null}
    </div>
  );
};

export default CheckBox;
